import { Component, OnInit } from '@angular/core';

import { TAAConstants } from '../constants/taa-constants';
import { CommonService } from '../services/common.service';
import { AppService } from '../services/app.service';
import { Configuration } from '../services/configuration.model';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  providers: [CommonService]
})
export class ContactusComponent implements OnInit {
  public dynamicContent: any;
  public phoneText: any;
  public emailText: any;
  public infoText: any;
  public showEmail: boolean = false;
  public showInfo: boolean = false;
  private config: Configuration;

  constructor(private _commonService: CommonService,
    public taaConstants: TAAConstants,
    private appService: AppService) {
    this.appService.getConfiguration().then(config => {
      this.config = config;
      if (config.success.enabled) {
        window.location.href = this.config.success.contactUrl;
      }
    });
  }

  ngOnInit() {
    const email = this.taaConstants.getCONTACT_EMAIL();
    const phone = this.taaConstants.getCONTACT_PHONE();
    const info = this.taaConstants.getCONTACT_INFO();

    this._commonService.getDynamicContent(info).toPromise().then(response => {
      const contentValue = response[0].DYNAMIC_CONTENT_VAL;
      if (contentValue && contentValue.trim() !== '') {
        this.infoText = contentValue;
        this.showInfo = true;
      } else {
        this.showEmail = true;
        this._commonService.getDynamicContent(email).toPromise().then(emailResponse => {
          this.emailText = emailResponse[0].DYNAMIC_CONTENT_VAL;
        });
        this._commonService.getDynamicContent(phone).toPromise().then(phoneResponse => {
          this.phoneText = phoneResponse[0].DYNAMIC_CONTENT_VAL;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/contactus/contactus.component.ts